/* Ability Warehouse — quote list.
   "Add to Quote" on every product page, "Add cart to quote" on the cart page, a "Quote" button next to the header cart,
   a right-hand quote drawer (same look and behaviour as the cart drawer), and the /pages/quote page (list + product search
   rendered here; the request form is in sections/main-quote.liquid).
   The list lives in this browser (localStorage 'awQuote:v1') until the request is sent: the drawer and the quote page both
   read and edit that one list, and every change fires 'awquote:change' so both stay in step. */
(function () {
  'use strict';
  if (window.AWQuote) return;
  var KEY = 'awQuote:v1', QUOTE_URL = '/pages/quote';
  var money = function (c) { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((c || 0) / 100); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };
  /* Stored items are untrusted (any script or extension can write localStorage): numbers are coerced, links must be
     same-site paths and images http(s) or site-relative, so nothing stored can become markup or a javascript: link. */
  var safeUrl = function (u) { u = String(u || ''); return /^\/(?![\/\\])/.test(u) ? u : '#'; };
  var safeImg = function (u) { u = String(u || ''); return /^(https?:)?\/\/[^\s"'<>]+$/i.test(u) || /^\/(?![\/\\])[^\s"'<>]*$/.test(u) ? u : ''; };
  function clean(i) {
    return { id: +i.id || 0, title: String(i.title == null ? '' : i.title), variant: String(i.variant == null ? '' : i.variant), price: +i.price || 0, img: String(i.img || ''), url: String(i.url || ''), qty: Math.max(1, parseInt(i.qty, 10) || 1) };
  }
  var mem = [];
  function read() {
    var list;
    try { var v = JSON.parse(localStorage.getItem(KEY)); list = Array.isArray(v) ? v : (v ? [] : mem); } catch (e) { list = mem; }
    return list.filter(function (i) { return i && typeof i === 'object'; }).map(clean).filter(function (i) { return i.id > 0; });
  }
  function write(list) { mem = list; try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} changed(); }
  function changed() { headerLink(); document.dispatchEvent(new CustomEvent('awquote:change')); }
  function count() { return read().reduce(function (n, i) { return n + (i.qty || 0); }, 0); }
  function add(item) {
    var list = read(), hit = list.filter(function (i) { return i.id === item.id; })[0];
    if (hit) hit.qty += item.qty; else list.push(item);
    write(list);
  }
  function setQty(id, q) { var list = read().map(function (i) { if (i.id === id) i.qty = Math.max(1, q); return i; }); write(list); }
  function remove(id) { write(read().filter(function (i) { return i.id !== id; })); }
  function clear() { write([]); }
  /* another tab changed the list */
  window.addEventListener('storage', function (e) { if (e.key === KEY) changed(); });

  /* ---------- styles: add button, header link, drawer extras ---------- */
  function css() {
    if (document.getElementById('awq-css')) return;
    var s = document.createElement('style'); s.id = 'awq-css';
    s.textContent = '.awq-add{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;min-height:52px;margin-top:10px;border:1.5px solid var(--navy,#1E2A4A);border-radius:14px;background:#fff;color:var(--navy,#1E2A4A);font:700 16px Inter,sans-serif;cursor:pointer}' +
      '.awq-add:hover{background:#F4F1E8}.awq-add svg{width:18px;height:18px}.awq-add[aria-busy=true]{opacity:.7;cursor:progress}' +
      '.header__quote{position:relative;display:inline-flex;align-items:center;justify-content:center;gap:8px;width:42px;height:42px;padding:0;border-radius:6px;color:var(--ink,#1E2A4A);text-decoration:none;font-weight:800}' +
      '.header__quote svg{width:22px;height:22px}.header__quote-label{display:none}' +
      '.header__quote b{position:absolute;top:2px;right:2px;display:grid;place-items:center;min-width:18px;height:18px;padding:0 4px;border-radius:999px;background:var(--red,#D7141E);color:#fff;font-size:11px;font-weight:800}' +
      '.header__quote b[hidden]{display:none}html.search-open .header__quote{display:none}' +
      '@media (min-width:990px){.header__quote{width:auto;height:50px;padding:0 16px;margin-right:6px;border:1.5px solid var(--navy,#1E2A4A);background:#fff;color:var(--navy,#1E2A4A)}.header__quote:hover{background:#F4F1E8;color:var(--navy,#1E2A4A)}.header__quote-label{display:inline}.header__quote b{position:static;min-width:20px;height:20px;font-size:12px;background:var(--yellow,#FFD500);color:var(--ink,#1E2A4A)}}' +
      '.awq-toast{position:fixed;left:50%;bottom:calc(24px + env(safe-area-inset-bottom,0px));transform:translateX(-50%);z-index:70;display:flex;align-items:center;gap:14px;max-width:calc(100% - 32px);padding:12px 16px;border-radius:12px;background:#1E2A4A;color:#fff;font:600 14px Inter,sans-serif;box-shadow:0 14px 30px -12px rgba(14,22,42,.7)}' +
      '.awq-toast a{color:#FFD23F;font-weight:800;white-space:nowrap}' +
      /* quote drawer: reuses the cart drawer classes (.cd, .cd__panel, .cd__head ...) so it looks and moves the same */
      '.awqd .cd__head .icon-btn{display:inline-grid;place-items:center;width:44px;height:44px;border:0;background:none;color:var(--ink,#1E2A4A);cursor:pointer}' +
      '.awqd .cd__head .icon-btn svg{width:22px;height:22px}' +
      '.awqd .cd__img{display:block;width:72px;height:72px;border-radius:6px;background:var(--soft,#F4F6F9)}' +
      '.awqd .cd__img img{display:block}' +
      '.awqd .cd__price strong{color:#0E2A47}' +
      '.awqd .cd__tot>span:first-child{display:grid;line-height:1.2}.awqd .cd__tot small{font-weight:400;font-size:12px;color:var(--muted,#5B6573)}' +
      '.awqd__go{display:flex;align-items:center;justify-content:center;width:100%;min-height:52px;border-radius:12px;font-size:16px}' +
      '.awqd .cd__dline{text-align:center}';
    document.head.appendChild(s);
  }
  function headerLink() {
    css();
    var n = count(), cart = document.querySelector('.header__cart'); if (!cart) return;
    var el = document.querySelector('.header__quote');
    if (!el) {
      el = document.createElement('a'); el.className = 'header__quote'; el.href = QUOTE_URL;
      el.setAttribute('aria-haspopup', 'dialog'); el.setAttribute('aria-controls', 'QuoteDrawer');
      el.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l5 5v13H7z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M14 3v5h5M10 13h6M10 17h6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span class="header__quote-label">Quote</span><b hidden></b>';
      cart.parentNode.insertBefore(el, cart);
    }
    var b = el.querySelector('b'); b.hidden = !n; b.textContent = n;
    el.setAttribute('aria-label', 'Your quote, ' + n + (n === 1 ? ' item' : ' items'));
  }
  function toast(msg) {
    css();
    var t = document.querySelector('.awq-toast'); if (t) t.remove();
    t = document.createElement('div'); t.className = 'awq-toast'; t.setAttribute('role', 'status');
    t.innerHTML = '<span>' + esc(msg) + '</span><a href="' + QUOTE_URL + '">View quote →</a>';
    document.body.appendChild(t); setTimeout(function () { if (t.parentNode) t.remove(); }, 5000);
  }

  /* ---------- quote drawer ---------- */
  var dw = null, panel = null, lastFocus = null;
  function img(src, w) {
    src = safeImg(src);
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (/\/cdn\/shop\/|cdn\.shopify\.com/.test(src) && !/[?&]width=/.test(src)) src += (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
    return src;
  }
  function cartWrap() { return document.querySelector('[data-cart-drawer]'); }
  function build() {
    if (dw) return dw;
    css();
    var x = document.querySelector('[data-cart-drawer] .cd__head .icon-btn svg');
    var xsvg = x ? x.outerHTML : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    dw = document.createElement('div');
    dw.className = 'cd awqd'; dw.id = 'QuoteDrawer'; dw.hidden = true; dw.setAttribute('data-quote-drawer', '');
    dw.innerHTML = '<div class="cd__backdrop" data-qd-close></div>' +
      '<aside class="cd__panel" role="dialog" aria-modal="true" aria-labelledby="QuoteDrawerTitle" tabindex="-1">' +
      '<div class="cd__inner"><div class="cd__head"><p class="cd__title display" id="QuoteDrawerTitle">Your quote</p>' +
      '<button type="button" class="icon-btn" data-qd-close aria-label="Close quote">' + xsvg + '</button></div>' +
      '<div class="cd__msg" data-qd-msg role="status" aria-live="polite"></div><div class="awqd__content" data-qd-content style="display:contents"></div></div></aside>';
    document.body.appendChild(dw);
    panel = dw.querySelector('.cd__panel');
    dw.addEventListener('click', function (e) {
      if (e.target.closest('[data-qd-close]')) { close(); return; }
      var li = e.target.closest('[data-qd-id]'); if (!li) return;
      var id = +li.getAttribute('data-qd-id'), it = read().filter(function (i) { return i.id === id; })[0]; if (!it) return;
      if (e.target.closest('[data-qd-remove]')) { remove(id); focusAfter = null; return; }
      var b = e.target.closest('[data-qd-q]');
      if (b) { var d = +b.getAttribute('data-qd-q'), q = it.qty + d; focusAfter = q > 0 ? [id, d] : null; if (q < 1) remove(id); else setQty(id, q); }
    });
    dw.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-qd-input]'); if (!inp) return;
      var id = +inp.getAttribute('data-qd-input'), q = parseInt(inp.value, 10);
      if (isNaN(q)) q = 1;
      if (q < 1) remove(id); else setQty(id, q);
    });
    document.addEventListener('awquote:change', render);
    /* the cart drawer opening closes this one */
    var cw = cartWrap();
    if (cw && window.MutationObserver) new MutationObserver(function () {
      if (cw.classList.contains('is-open') && isOpen()) close(true);
    }).observe(cw, { attributes: true, attributeFilter: ['class'] });
    return dw;
  }
  var focusAfter = null;
  function render() {
    if (!dw) return;
    var list = read(), n = count(), box = dw.querySelector('[data-qd-content]');
    dw.querySelector('#QuoteDrawerTitle').innerHTML = 'Your quote' + (n > 0 ? ' <span>(' + n + ')</span>' : '');
    if (!list.length) {
      box.innerHTML = '<div class="cd__empty"><p class="display h4">Your quote list is empty</p>' +
        '<p>Tap <b>Add to Quote</b> on any product to build your list.</p>' +
        '<a class="btn btn--red btn--block" href="/collections/all">Shop products</a></div>';
      return;
    }
    var tot = list.reduce(function (s, i) { return s + (+i.price || 0) * i.qty; }, 0);
    box.innerHTML = '<div class="cd__body"><ul class="cd__lines">' + list.map(function (i) {
      var src = img(i.img, 160);
      return '<li class="cd__line" data-qd-id="' + i.id + '">' +
        '<a class="cd__img" href="' + esc(safeUrl(i.url)) + '" tabindex="-1" aria-hidden="true">' + (src ? '<img src="' + esc(src) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
        '<div class="cd__info"><a class="cd__name" href="' + esc(safeUrl(i.url)) + '">' + esc(i.title) + '</a>' +
        (i.variant ? '<p class="cd__prop">' + esc(i.variant) + '</p>' : '') +
        '<div class="cd__row"><div class="cd__qty" role="group" aria-label="Quantity">' +
        '<button type="button" data-qd-q="-1" aria-label="One fewer">−</button>' +
        '<input type="number" min="0" value="' + i.qty + '" inputmode="numeric" data-qd-input="' + i.id + '" aria-label="Quantity for ' + esc(i.title) + '">' +
        '<button type="button" data-qd-q="1" aria-label="One more">+</button></div>' +
        '<button type="button" class="cd__remove" data-qd-remove aria-label="Remove ' + esc(i.title) + '">Remove</button></div></div>' +
        '<div class="cd__price">' + (+i.price > 0 ? '<strong class="num">' + money(i.price * i.qty) + '</strong>' : '') + '</div></li>';
    }).join('') + '</ul></div>' +
      '<div class="cd__foot cd__foot--v2">' +
      (tot > 0 ? '<div class="cd__tot"><span>Estimated total<small>before delivery</small></span><span class="cd__tot-p"><b class="num">' + money(tot) + '</b></span></div>' : '') +
      '<a class="btn btn--red btn--block awqd__go" href="' + QUOTE_URL + '">Request quote</a>' +
      '<p class="cd__dline">Add your details on the next page and we\'ll email a written quote.</p></div>';
    if (focusAfter) {
      var f = box.querySelector('[data-qd-id="' + focusAfter[0] + '"] [data-qd-q="' + focusAfter[1] + '"]');
      if (f) f.focus();
      focusAfter = null;
    } else if (isOpen() && !panel.contains(document.activeElement)) panel.focus();
  }
  function msg(html, type) { build(); var m = dw.querySelector('[data-qd-msg]'); m.className = 'cd__msg' + (type ? ' cd__msg--' + type : ''); m.innerHTML = html || ''; }
  function isOpen() { return !!(dw && dw.classList.contains('is-open')); }
  function open() {
    build();
    /* close the cart drawer first (it restores focus and unlocks scroll synchronously) */
    var cw = cartWrap();
    if (cw && cw.classList.contains('is-open')) { var cx = cw.querySelector('[data-cd-close]'); if (cx) cx.click(); }
    if (!isOpen()) lastFocus = document.activeElement;
    render();
    dw.hidden = false;
    void panel.offsetWidth;
    dw.classList.add('is-open');
    document.body.classList.add('no-scroll');
    setTimeout(function () { panel.focus(); }, 30);
  }
  function close(forCart) {
    if (!dw || !isOpen()) return;
    dw.classList.remove('is-open');
    if (!forCart) document.body.classList.remove('no-scroll');
    setTimeout(function () { if (!dw.classList.contains('is-open')) { dw.hidden = true; msg(''); } }, 200);
    if (!forCart && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.header__quote, [data-quote-open]');
    if (!a || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault(); open();
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled]), input, [tabindex="0"]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- product page: Add to Quote ---------- */
  function productPage() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/); if (!m) return;
    var anchor = document.querySelector('.awq-links') || document.querySelector('.buybox'); if (!anchor) return;
    var form = document.querySelector('form.calc') || document.querySelector('form[action*="/cart/add"]');
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'awq-add';
    btn.setAttribute('aria-haspopup', 'dialog'); btn.setAttribute('aria-controls', 'QuoteDrawer');
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l5 5v13H7z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M14 3v5h5M10 13h6M10 17h6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>Add to Quote';
    anchor.parentNode.insertBefore(btn, anchor);
    var loading = fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    loading.catch(function () {});
    btn.addEventListener('click', function () {
      btn.setAttribute('aria-busy', 'true');
      loading.then(function (prod) {
        var idEl = form && form.querySelector('[name="id"]'), qEl = form && form.querySelector('[name="quantity"]');
        var vid = +(idEl && idEl.value) || prod.variants[0].id;
        var v = prod.variants.filter(function (x) { return x.id === vid; })[0] || prod.variants[0];
        var qty = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
        var im = (v.featured_image && v.featured_image.src) || prod.featured_image || '';
        if (im && im.indexOf('//') === 0) im = 'https:' + im;
        add({ id: v.id, title: prod.title, variant: v.title === 'Default Title' ? '' : v.title, price: v.price, img: im, url: '/products/' + prod.handle + '?variant=' + v.id, qty: qty });
        msg('<span class="cd__tick" aria-hidden="true">✓</span> Added ' + (qty > 1 ? qty + ' × ' : '') + esc(prod.title) + ' to your quote', 'ok');
        open();
      }).catch(function () {
        toast('Sorry, that could not be added. Please try again.');
      }).then(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- cart page: Add cart to quote ----------
     Sits under Checkout and the ticks in the cart summary (.csum on section.cart--v2; .summary as a fallback). cart-drawer.js
     re-renders section.cart after every cart change, so the button is put back whenever the section is swapped. */
  function cartPage() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    function place() {
      var sum = document.querySelector('section.cart--v2 .csum') || document.querySelector('.summary'); if (!sum || sum.querySelector('[data-awq-cart]')) return;
      var anchor = sum.querySelector('.cticks') || sum.querySelector('[data-csum-go]') || sum.querySelector('[name="checkout"]') || sum.querySelector('.btn--red'); if (!anchor) return;
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'btn btn--line btn--block btn--sm'; btn.setAttribute('data-awq-cart', '');
      btn.setAttribute('aria-haspopup', 'dialog'); btn.setAttribute('aria-controls', 'QuoteDrawer');
      btn.textContent = 'Add cart to quote';
      anchor.parentNode.insertBefore(btn, anchor.nextSibling);
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-awq-cart]'); if (!btn) return;
      btn.disabled = true;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var n = 0;
        cart.items.forEach(function (i) {
          if (i.handle === 'membership') return;
          n += i.quantity;
          add({ id: i.variant_id, title: i.product_title, variant: i.variant_title || '', price: i.original_price, img: i.image || '', url: i.url, qty: i.quantity });
        });
        msg(n ? '<span class="cd__tick" aria-hidden="true">✓</span> Added your cart items to your quote' : '', n ? 'ok' : '');
        open(); btn.disabled = false;
      }).catch(function () { btn.disabled = false; });
    });
    place();
    var sec = document.querySelector('section.cart'), holder = sec && sec.parentNode;
    if (holder && window.MutationObserver) new MutationObserver(place).observe(holder, { childList: true });
  }

  /* ---------- quote page ---------- */
  function quotePage() {
    var root = document.querySelector('[data-quote]'); if (!root) return;
    if (root.querySelector('[data-quote-posted]')) { clear(); return; }
    var listEl = root.querySelector('[data-quote-list]'), empty = root.querySelector('[data-quote-empty]'), sum = root.querySelector('[data-quote-sum]');
    var totalEl = root.querySelector('[data-quote-total]'), body = root.querySelector('[data-quote-body]');
    function render() {
      var list = read();
      empty.hidden = list.length > 0; sum.hidden = list.length === 0;
      listEl.innerHTML = list.map(function (i) {
        var src = safeImg(i.img);
        return '<li class="q-line" data-id="' + i.id + '">' +
          (src ? '<img class="q-img" src="' + esc(src) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="q-img"></span>') +
          '<div class="q-info"><a class="q-title" href="' + esc(safeUrl(i.url)) + '">' + esc(i.title) + '</a>' + (i.variant ? '<span class="q-var">' + esc(i.variant) + '</span>' : '') +
          '<span class="q-unit">' + money(i.price) + ' each</span></div>' +
          '<div class="q-qty" role="group" aria-label="Quantity"><button type="button" data-q="-1" aria-label="One fewer">−</button><input type="number" min="1" value="' + i.qty + '" inputmode="numeric" aria-label="Quantity for ' + esc(i.title) + '"><button type="button" data-q="1" aria-label="One more">+</button></div>' +
          '<b class="q-line-total">' + money(i.price * i.qty) + '</b>' +
          '<button type="button" class="q-remove" data-remove aria-label="Remove ' + esc(i.title) + '">Remove</button></li>';
      }).join('');
      var tot = list.reduce(function (s, i) { return s + i.price * i.qty; }, 0);
      if (totalEl) totalEl.textContent = money(tot);
    }
    /* the drawer (or another tab) edits the same list */
    document.addEventListener('awquote:change', render);
    listEl.addEventListener('click', function (e) {
      var li = e.target.closest('.q-line'); if (!li) return;
      var id = +li.getAttribute('data-id'), it = read().filter(function (i) { return i.id === id; })[0]; if (!it) return;
      if (e.target.closest('[data-remove]')) { remove(id); render(); return; }
      var b = e.target.closest('[data-q]'); if (b) { setQty(id, it.qty + (+b.getAttribute('data-q'))); render(); }
    });
    listEl.addEventListener('change', function (e) {
      var li = e.target.closest('.q-line'); if (!li || e.target.tagName !== 'INPUT') return;
      setQty(+li.getAttribute('data-id'), parseInt(e.target.value, 10) || 1); render();
    });

    /* search to add */
    var input = root.querySelector('[data-q-input]'), res = root.querySelector('[data-q-results]'), wrap = root.querySelector('[data-q-search]');
    var items = null, timer, shown = [];
    function ensure() {
      if (items || !window.CWIndex) return Promise.resolve(items || []);
      return window.CWIndex.load('/collections/all').then(function (all) { items = all; return all; }).catch(function () { return []; });
    }
    function draw(q) {
      q = q.trim();
      if (q.length < 2) { res.hidden = true; res.innerHTML = ''; return; }
      ensure().then(function (all) {
        if (input.value.trim() !== q) return;
        shown = window.CWIndex ? window.CWIndex.search(all, q).slice(0, 8) : [];
        res.innerHTML = shown.length ? shown.map(function (it, n) {
          var src = it.im ? (window.CWIndex.img(it.im, 120)) : '';
          return '<li class="q-r" data-n="' + n + '">' + (src ? '<img src="' + esc(src) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="ph"></span>') +
            '<span class="q-r__t">' + esc(it.t) + '<small>' + money(it.p) + (it.a === false || it.a === 0 ? ' · Sold out' : '') + '</small></span>' +
            '<span class="q-r__go"><button type="button" class="q-r__add" data-add>Add</button></span></li>';
        }).join('') : '<li class="q-r__none">No matches. Add it under "other products" below and we\'ll source it.</li>';
        res.hidden = false;
      });
    }
    if (input) {
      input.addEventListener('focus', ensure);
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { draw(input.value); }, 140); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); draw(input.value); } if (e.key === 'Escape') { res.hidden = true; } });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) res.hidden = true; });
      res.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-add]'); if (!btn) return;
        var row = btn.closest('.q-r'), it = shown[+row.getAttribute('data-n')]; if (!it) return;
        var sel = row.querySelector('select');
        function done(p, v) {
          var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          add({ id: v.id, title: p.title, variant: v.title === 'Default Title' ? '' : v.title, price: v.price, img: img, url: '/products/' + p.handle + '?variant=' + v.id, qty: 1 });
          render(); btn.textContent = 'Added ✓'; btn.classList.add('is-done');
          setTimeout(function () { btn.textContent = 'Add'; btn.classList.remove('is-done'); }, 1600);
        }
        if (row._p && sel) { var v = row._p.variants.filter(function (x) { return x.id === +sel.value; })[0]; if (v) done(row._p, v); return; }
        btn.disabled = true;
        fetch('/products/' + it.h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
          btn.disabled = false; row._p = p;
          var vs = p.variants.filter(function (v) { return v.available; }); if (!vs.length) vs = p.variants;
          if (vs.length > 1) {
            var s = document.createElement('select'); s.setAttribute('aria-label', 'Option for ' + p.title);
            s.innerHTML = vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + ' · ' + money(v.price) + '</option>'; }).join('');
            btn.parentNode.insertBefore(s, btn); btn.textContent = 'Add'; s.focus();
          } else done(p, vs[0]);
        }).catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
      });
    }

    /* submit */
    var form = root.querySelector('form'), msg = root.querySelector('[data-q-msg]'), other = root.querySelector('[data-q-other]');
    if (form) form.addEventListener('submit', function (e) {
      var list = read(), extra = other ? other.value.trim() : '';
      if (!list.length && !extra) {
        e.preventDefault(); msg.textContent = 'Add at least one product, or list products in "other products".'; msg.hidden = false;
        (input || other).focus(); return;
      }
      msg.hidden = true;
      var f = root.querySelector('[data-q-first]'), l = root.querySelector('[data-q-last]'), nm = root.querySelector('[data-q-name]');
      if (nm) nm.value = ((f ? f.value : '') + ' ' + (l ? l.value : '')).trim();
      var lines = list.map(function (i) { return i.qty + ' × ' + i.title + (i.variant ? ' (' + i.variant + ')' : '') + ' @ ' + money(i.price) + ' = ' + money(i.price * i.qty) + '  ' + location.origin + safeUrl(i.url); });
      var tot = list.reduce(function (s, i) { return s + i.price * i.qty; }, 0);
      body.value = 'Quote request\n\n' + (lines.length ? lines.join('\n') + '\n\nEstimated total (before delivery): ' + money(tot) : 'No website products selected.') +
        (extra ? '\n\nOther products:\n' + extra : '');
    });
    render();
  }

  window.AWQuote = { add: add, list: read, count: count, clear: clear, setQty: setQty, remove: remove, open: open, close: close };
  function init() { headerLink(); build(); productPage(); cartPage(); quotePage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
